import cookie from 'js-cookie'

import { loginSuccess } from '../redux/auth'
import { SUPER_ADMINS, AUTH_COOKIE_KEY } from '../constants'

export function isAnonymous (user) {
  if (!user) {
    return false
  }
  return user.id === 0
}

export function isSuperAdmin (user) {
  if (!user) {
    return false
  }
  return SUPER_ADMINS.indexOf(user.id) !== -1
}

export function userHasPerm (user, perm) {
  if (!user) {
    return false
  }
  return user.perms.findIndex(p => p.perm.perm_token === perm) !== -1
}

export function canDownload (auth) {
  if (isAnonymous(auth.user)) {
    return !auth.no_download
  }
  return userHasPerm(auth.user, 'download')
}

export function restoreSession (store) {
  // Skip session restore if share parameter is set
  if (window.location.search === '?share') {
    return
  }
  // Skip session restore for external share URLs
  if (/^\/share/.test(window.location.pathname)) {
    return
  }
  const auth = cookie.getJSON(AUTH_COOKIE_KEY)
  if (auth) {
    if (!auth.path || auth.path === window.location.pathname) {
      store.dispatch(loginSuccess(auth))
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js